// src/pages/Carts.js
import React, { useState, useEffect } from 'react';
import { fetchAbandonedCarts } from '../services/cartService';
import { useAuth } from '../context/AuthContext';
import LoadingScreen from '../components/LoadingScreen';

function Carts() {
  const { userData } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [carts, setCarts] = useState([]);
  const [filters, setFilters] = useState({
    startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0],
  });

  useEffect(() => {
    const fetchCartsData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Llamar al servicio con manejo de errores integrado
        const response = await fetchAbandonedCarts({ ...filters });
        
        // Procesamiento defensivo de datos con diagnóstico
        let processedCarts = [];
        
        try {
          // Inspeccionar la estructura de respuesta
          const cartsData = response?.data;
          const isDataArray = Array.isArray(cartsData);
          const hasCartsArray = cartsData && 
                             typeof cartsData === 'object' && 
                             Array.isArray(cartsData.carts);
          const isHTML = typeof cartsData === 'string' && 
                      (cartsData.includes('<!DOCTYPE') || cartsData.includes('<html'));
          
          // Registrar diagnóstico para debugging
          localStorage.setItem('nubelytics_carts_response', JSON.stringify({
            type: typeof cartsData,
            isArray: isDataArray,
            hasCartsArray: hasCartsArray,
            isHTML: isHTML,
            timestamp: new Date().toISOString(),
            sample: isHTML ? cartsData.substring(0, 50) + '...' : null
          }));
          
          // Normalizar datos según la estructura recibida
          if (isDataArray) {
            processedCarts = cartsData;
          } else if (hasCartsArray) {
            processedCarts = cartsData.carts;
          }
          
          console.log('[Carts] Datos procesados:', {
            original: typeof cartsData === 'string' ? cartsData.substring(0, 100) + '...' : cartsData,
            processed: processedCarts,
            isArray: Array.isArray(processedCarts)
          });
        } catch (e) {
          console.error('[Carts] Error procesando datos:', e);
        }
        
        // Garantizar que siempre asignamos un array
        setCarts(Array.isArray(processedCarts) ? processedCarts : []);
      } catch (err) {
        console.error('[Carts] Error cargando carritos abandonados:', err);
        setError('No se pudieron cargar los carritos abandonados.');
      } finally {
        setLoading(false);
      }
    };
    
    if (userData) fetchCartsData();
  }, [userData, filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  if (loading) return <LoadingScreen />;

  return (
    <div className="carts-page">
      <h1>Carritos Abandonados</h1>
      {error && <div className="alert error">{error}</div>}
      <div className="filters-section">
        <label>Desde:
          <input type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} />
        </label>
        <label>Hasta:
          <input type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} />
        </label>
      </div>
      <div className="carts-table">
        <table>
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Cliente</th>
              <th>Valor</th>
              <th>Recuperar</th>
            </tr>
          </thead>
          <tbody>
            {carts.length === 0 ? (
              <tr><td colSpan="4">No hay carritos abandonados en el período seleccionado.</td></tr>
            ) : (
              carts.map((cart, i) => (
                <tr key={i}>
                  <td>{cart.createdAt ? new Date(cart.createdAt).toLocaleString() : ''}</td>
                  <td>{cart.customerId || 'Sin identificar'}</td>
                  <td>${cart.subtotalPrice?.toLocaleString() || 0}</td>
                  <td>
                    {cart.abandonedUrl ? (
                      <a href={cart.abandonedUrl} target="_blank" rel="noopener noreferrer">Recuperar</a>
                    ) : '—'}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <style jsx="true">{`
        .carts-page { max-width: 900px; margin: 0 auto; }
        .filters-section { display: flex; gap: 20px; margin-bottom: 20px; }
        .filters-section label { display: flex; flex-direction: column; font-size: 0.95rem; }
        .carts-table { overflow-x: auto; background: #fff; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05); }
        table { width: 100%; border-collapse: collapse; }
        th, td { padding: 10px 15px; border-bottom: 1px solid #e9ecef; }
        th { background: #f8f9fa; text-align: left; }
        .alert.error { background: #f8d7da; color: #721c24; padding: 10px; border-radius: 4px; margin-bottom: 20px; }
      `}</style>
    </div>
  );
}

export default Carts;
